import { deleteProduct, updateProduct, createProduct, fetchProducts, fetchProduct } from 'api';
import useAxios from 'hooks/useAxios';
import { IProductResource } from '../../server/types';

const useDeleteProduct = () => {
  const [request, { loading, error }] = useAxios<IProductResource>();

  const handleDeleteProduct = async (id: string) => {
    await request(deleteProduct(id));
  };

  return [handleDeleteProduct, { loading, error }] as const;
};

const useCreateProduct = () => {
  const [request, { loading, error }] = useAxios<IProductResource>();

  const handleCreateProduct = async (data: IProductResource) => {
    const addedProduct = await request(createProduct(data));

    return addedProduct;
  };

  return [handleCreateProduct, { loading, error }] as const;
};

const useUpdateProduct = () => {
  const [request, { loading, error }] = useAxios<IProductResource>();

  const handleUpdateProduct = async (id: string, data: Partial<IProductResource>) => {
    const updatedProduct = await request(updateProduct(id, data));
    return updatedProduct;
  };
  return [handleUpdateProduct, { loading, error }] as const;
};

const useFetchProducts = () => {
  const [request, { loading, error, data }] = useAxios<{ products: IProductResource[] }>();
  const handleFetchProducts = () => request(fetchProducts());
  return [handleFetchProducts, { loading, error, data }] as const;
};

const useFetchProduct = () => {
  const [request, { loading, error, data }] = useAxios<IProductResource>();
  const handleGetProduct = (id: string) => request(fetchProduct(id));
  return [handleGetProduct, { loading, error, data }] as const;
};

export { useDeleteProduct, useCreateProduct, useUpdateProduct, useFetchProducts, useFetchProduct };
